import Loader from "./Loader";

export { LoaderComponent, BoxedLoader, TransparentLoader } from "./Loader";

export default Loader;
